const apiUrl = process.env.REACT_APP_API_URL;
export const GetAlumneAulesId = async (id_aula: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/alumnes/aules/${id_aula}/tots`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
